export default __webpack_public_path__ + "static/media/uv5_kr_head_a1.52d0d05a.mp3";